import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const SECTIONS = [
  { id: 'my-safaricom-partner-portal-redesign', label: 'Summary' },
  { id: 'results-at-a-glance',                  label: 'Results at a Glance' },
  { id: 'the-challenge',                         label: 'A Day in the Life' },
  { id: 'the-vision',                            label: 'The Vision' },
  { id: 'discovery-phase',                       label: 'Discovery' },
  { id: 'the-solution',                          label: 'The Solution' },
  { id: 'technical-leadership',                  label: 'Technical Leadership' },
  { id: 'impact-and-results',                    label: 'Impact & Results' },
  { id: 'reflections',                           label: 'Reflections' },
];

const Container = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 4px;
`;

const NavLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  padding: 6px 10px;
  border-radius: 8px;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active }) => ($active ? '#030e49' : 'inherit')};
  opacity: ${({ $active }) => ($active ? 1 : 0.4)};
  background: ${({ $active }) => ($active ? 'var(--color-surface)' : 'transparent')};
  letter-spacing: 0;
  line-height: 1.4;
  transition: opacity 0.18s ease, background 0.18s ease, color 0.18s ease;
  white-space: nowrap;

  &:hover {
    opacity: 1;
    background: var(--color-surface);
    color: #030e49;
  }
`;

const Dot = styled.span`
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--color-primary);
  transition: opacity 0.18s ease, transform 0.18s ease;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transform: ${({ $active }) => ($active ? 'scale(1)' : 'scale(0)')};
`;

function getActiveIndex() {
  if (typeof window === 'undefined') return 0;
  const offsets = SECTIONS.map(({ id }) => {
    const el = document.getElementById(id);
    if (!el) return Infinity;
    return Math.abs(el.getBoundingClientRect().top - 120);
  });
  return offsets.indexOf(Math.min(...offsets));
}

const OutlineScheduler = () => {
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const onScroll = () => setActiveIdx(getActiveIndex());
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Container aria-label="Page outline">
      {SECTIONS.map(({ id, label }, i) => (
        <NavLink key={id} href={`#${id}`} $active={i === activeIdx}>
          <Dot $active={i === activeIdx} />
          {label}
        </NavLink>
      ))}
    </Container>
  );
};

export default OutlineScheduler;
